import { useRef, useState } from 'react';
import { useOnClickOutside } from '../../../../../../hooks/useOnClickOutside';

export const useDropdownMenu = () => {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  useOnClickOutside(ref, handleClose);

  return { ref, open, handleToggle, handleClose, handleOpen };
};
